import { render, staticRenderFns } from "./mokuai65.vue?vue&type=template&id=52ec4ffe&"
import script from "./mokuai65.vue?vue&type=script&lang=js&"
export * from "./mokuai65.vue?vue&type=script&lang=js&"
import style0 from "./mokuai65.vue?vue&type=style&index=0&id=52ec4ffe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports